import React from 'react';

import lediumApi from '@client/utils/lediumApi';
import { LightChannelDoc } from '@ledium/types';

const useChannelList = (): LightChannelDoc[] => {
    // channels in autocomplete select. add new channel could add new items
    const [channelList, setChannelList] = React.useState<LightChannelDoc[]>([]);

    React.useEffect(() => {
        lediumApi.get<LightChannelDoc[]>('lightChannels').then((result) => {
            if (result) {
                setChannelList(result);
            }
        });
    }, []);

    return channelList;
};

export default useChannelList;
